var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.625,
    height: 28.625,
    viewBox: "0 0 28.625 28.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165567",
    "data-name": "Grupo 165567",
    transform: "translate(7505.789 -4037.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165566",
    "data-name": "Grupo 165566",
    transform: "translate(991.711 914.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_501",
    "data-name": "L\\xEDnea 501",
    d: "M26.118,27.625a1.5,1.5,0,0,1-1.065-.441L-.559,1.572A1.507,1.507,0,0,1,1.572-.559L27.183,25.053a1.507,1.507,0,0,1-1.065,2.572Z",
    transform: "translate(-8496.5 3124.5)",
    fill: "#05294f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_502",
    "data-name": "L\\xEDnea 502",
    d: "M.507,27.625A1.507,1.507,0,0,1-.559,25.053L25.053-.559a1.507,1.507,0,0,1,2.131,2.131L1.572,27.183A1.5,1.5,0,0,1,.507,27.625Z",
    transform: "translate(-8496.5 3124.5)",
    fill: "#05294f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruz);
export default __webpack_public_path__ + "static/media/cruz.1396099d0e92458ff14ee5410711c768.svg";
export { ForwardRef as ReactComponent };